// material-ui
import { useTheme } from '@mui/material/styles';
// import LogoPrimary from "../../assets/images/logo/CraneLogoLight.png"
// import CraneMainLogo from "../../assets/images/logo/CraneMainLogo.png"


import { ThemeMode } from 'types/config';
import useThemeConfig from 'hooks/useThemeConfig';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoIconDark from 'assets/images/logo-icon-dark.svg';
 * import logoIcon from 'assets/images/logo-icon.svg';
 *
 */

// ==============================|| LOGO ICON SVG ||============================== //

const LogoIcon = () => {
  const theme = useTheme();
  const { themeConfig } = useThemeConfig();

  // Get logo URL from theme config, fallback to default images
  const LogoPrimary = themeConfig?.icons?.square_logo_path?.url;
  const LogoPrimaryLight = themeConfig?.icons?.square_logo_path?.url;

  return (
    /**
     * if you want to use image instead of svg uncomment following, and comment out <svg> element.
     *
     * <img src={theme.palette.mode === ThemeMode.DARK ? logoIconDark : logoIcon} alt="icon logo" width="100" />
     *
     */
    <img src={theme.palette.mode === ThemeMode.DARK ? LogoPrimary : LogoPrimaryLight} alt="icon logo" width="50" />
  );
};

export default LogoIcon;
